import { AppBanner } from '@/components/ui';
import type { AssessmentResponse } from '@/lib/api/assessment';
import AssessmentResultBanner, {
  type AssessmentResultBannerLabels,
} from './AssessmentResultBanner';
import styles from './AssessmentStatusReveal.module.css';

type Props = {
  loading: boolean;
  assessment: AssessmentResponse | null;
  error: string | null;
  errorTitle: string;
  loadingLabel: string;
  loadingHint: string;
  labels: AssessmentResultBannerLabels;
};

export default function AssessmentStatusReveal({
  loading,
  assessment,
  error,
  errorTitle,
  loadingLabel,
  loadingHint,
  labels,
}: Props) {
  if (error) {
    return <AppBanner variant="danger" title={errorTitle} text={error} />;
  }

  if (loading || !assessment) {
    return (
      <div
        className={styles.loaderCard}
        role="status"
        aria-live="polite"
        aria-busy="true"
        data-testid="assessment-status-loading"
      >
        <div className={styles.loaderRing} aria-hidden />
        <p className={styles.loaderLabel}>{loadingLabel}</p>
        <p className={styles.loaderHint}>{loadingHint}</p>
      </div>
    );
  }

  return (
    <div className={styles.revealWrap} data-testid="assessment-status-reveal">
      <AssessmentResultBanner assessment={assessment} labels={labels} />
    </div>
  );
}
